import { Input } from 'antd';
import { type TextAreaProps } from 'antd/lib/input';
import { useCallback } from 'react';
import { useInputController } from '../hooks/useInputController.ts';
import { useFormItemAccessibility } from '../item/useFormItemAccessibility.tsx';
import { useFormItemEnabled } from '../item/useFormItemEnabled.ts';

const { TextArea } = Input;

export interface ITextAreaInputProps
  extends Omit<TextAreaProps, 'name' | 'onChange'> {
  name: string;
  onChange?: (value: string | null | undefined) => void;
}

/**
 * Campo per input area di testo.
 */
export function TextAreaInput(props: ITextAreaInputProps) {
  const { name, onChange: onAfterChange, ...inputProps } = props;

  const { enabled, visuallyDisabled } = useFormItemEnabled();

  const {
    field: { value, onChange, onBlur, ref },
  } = useInputController(name, { enabled });

  const accessibility = useFormItemAccessibility();

  const handleChange = useCallback(
    (e: any) => {
      onChange(e);
      if (onAfterChange) {
        onAfterChange(e.target.value);
      }
    },
    [onChange, onAfterChange],
  );

  return (
    <TextArea
      size="large"
      ref={ref}
      name={name}
      disabled={visuallyDisabled}
      {...accessibility.attributes}
      {...inputProps}
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
    />
  );
}
